/**
 * @ngdoc directive
 * @name ng.directive:ngVideoPlayer
 * @element ANY
 */

const ngVideoPlayer = ['$lazyScripts', ($lazyScripts) => {
    return {
        link: function ( $scope, $item, $params ) {

            $scope.bunny.videoElement = $item[0];
            $scope.bunny.videoElement.disablePictureInPicture = true;

            $lazyScripts.loadHls().then(() => {
                $scope.bunny.hls.native = $scope.bunny.videoElement.canPlayType('application/vnd.apple.mpegURL') || $scope.bunny.videoElement.canPlayType('audio/mpegurl');
                $scope.bunny.hls.supported = Hls.isSupported();

                // First check for native browser HLS support
                if ( $scope.service.player.sources.hls.length && ( $scope.bunny.hls.native || $scope.bunny.hls.supported)) {
                    $scope.bunny.sources.available = $scope.service.player.sources.hls;
                    // If no native HLS support, check if HLS.js is supported
                    if (!$scope.bunny.hls.native) {
                        $scope.bunny.hls.instance = new Hls({
                            maxMaxBufferLength: 15,
                        });
                    }
                } else {
                    $scope.bunny.sources.available = $scope.service.player.sources.mp4;
                }

                let defaultSource = null;
                angular.forEach($scope.bunny.sources.available, (source) => {
                    if ( source.default ) {
                        defaultSource = source;
                    }
                });
                if ( $scope.bunny.hls.instance) {
                     setTimeout(() => {
                        $scope.bunny.hls.instance.loadSource(defaultSource.link);
                        $scope.bunny.hls.instance.attachMedia($scope.bunny.videoElement);
                    }, 500 );
                } else {
                    $scope.bunny.videoElement.src = defaultSource.link;
                }
            });
        },
    };
}];

export default ngVideoPlayer;
